export default function({
    containerClass = 'label-floating'
} = {}) {
    // mimic "label" when wrapper is none
    $(`.${containerClass}:not(label)`).on('click', function () {
        $(this).find('input, textarea').focus();
    });

    $(`.${containerClass} input:not([type=submit]):not([type=file]), .${containerClass} textarea`)
        .on('focusin', function () {
            let $input = $(this),
                $container = $input.closest(`.${containerClass}`);

            $input.attr('placeholder', '');

            $container.addClass(`${containerClass}--active`)
                .addClass(`${containerClass}--focus`);
        })
        .on('focusout', function () {
            let $input = $(this),
                $container = $input.closest(`.${containerClass}`);

            $container.removeClass(`${containerClass}--focus`);

            if ($input.val()) {
                $container.addClass(`${containerClass}--active`);
            } else {
                $input.attr('placeholder', $input.data('placeholder'));
                $container.removeClass(`${containerClass}--active`);
            }
        })
        .each(function () {
            let $input = $(this),
                $container = $input.closest(`.${containerClass}`);

            if ($input.val() || $input.is(':focus')) {
                $container.addClass(`${containerClass}--active`);
            }
        });
}



// WEBPACK FOOTER //
// ./node_modules/@spinnwerk/form-helper/label-floating.js